import { takeLatest, put, call, select } from 'redux-saga/effects';
import { checkToken } from '../auth/sagas';
import { Urls } from '../../config/urls';
import { getTask, patchTask } from '../../services';
import {
  getMerchantMarketingConfigError,
  getMerchantMarketingConfigSuccess,
  MarketingActionType,
  updateMerchantMarketingConfigError,
  updateMerchantMarketingConfigSuccess,
} from './actions';
import { PanelStore } from '../interfaces';

function* getMerchantMarketingConfig(action: any) {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();

  const { response, error } = yield call(getTask, {
    url: Urls.api.marketingConfig,
    token: state.auth.token,
  });

  if (response) {
    yield put(getMerchantMarketingConfigSuccess(response));
  } else {
    yield put(getMerchantMarketingConfigError(error));
  }
}

function* updateMerchantMarketingConfig(action: any) {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();

  const { response, error } = yield call(patchTask, {
    url: Urls.api.marketingConfig,
    token: state.auth.token,
    body: action.payload,
  });

  if (response) {
    yield put(updateMerchantMarketingConfigSuccess(response));
  } else {
    yield put(updateMerchantMarketingConfigError(error));
  }
}

export function* getMerchantMarketingConfigSaga() {
  yield takeLatest(MarketingActionType.GET_MERCHANT_MARKETING_CONFIG, getMerchantMarketingConfig);
}

export function* updateMerchantMarketingConfigSaga() {
  yield takeLatest(MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG, updateMerchantMarketingConfig);
}
